var createStore = require('redux').createStore;

var reducer = function (state, action) {
  if (state === undefined) {
    return {};
  }
  var newState = state;
  switch (action.type) {
    case 'set_language':
      newState = Object.assign({}, state, { locale: action.lang });
      break;
  }
  return newState;
}

module.exports = {
  configureStore: function (initialState) {
    return createStore(reducer, initialState)
  }
}



// WEBPACK FOOTER //
// ./js/redux/redux-store.js